import { apiClient } from "./client";

/** Telegram-канал тенанта (FR-TGC-01): '@channel' або '-100…'. */
export interface TgChannelSettings {
  chat_id: string | null;
}

export const tgChannelApi = {
  get: () => apiClient.get<TgChannelSettings>("/tg-channel").then((r) => r.data),
  put: (chat_id: string | null) =>
    apiClient.put<TgChannelSettings>("/tg-channel", { chat_id }).then((r) => r.data),
  test: () => apiClient.post<{ ok: boolean }>("/tg-channel/test").then((r) => r.data),
  sendFinanceReport: (date: string) =>
    apiClient
      .post<{ sent_at: string; is_edit: boolean }>("/tg-channel/finance-report", { date })
      .then((r) => r.data),
  sendPlanFact: (date: string) =>
    apiClient
      .post<{ sent_at: string; is_edit: boolean }>("/tg-channel/plan-fact", { date })
      .then((r) => r.data),
};

/** Код і деталі помилки API: бекенд віддає `{detail: {error: {...}}}`. */
export function apiErrorOf(e: unknown): { code?: string; details: Record<string, unknown> } {
  const data = (e as { response?: { data?: Record<string, unknown> } })?.response?.data;
  const err = ((data?.detail as { error?: unknown } | undefined)?.error ?? data?.error) as
    | { code?: string; details?: Record<string, unknown> }
    | undefined;
  return { code: err?.code, details: err?.details ?? {} };
}
